"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true,
});

var _slicedToArray = (function() {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (
        var _i = arr[Symbol.iterator](), _s;
        !(_n = (_s = _i.next()).done);
        _n = true
      ) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function(arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance"
      );
    }
  };
})();

var _createClass = (function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

const { el } = require("date-fns/locale");
var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  }
  return call && (typeof call === "object" || typeof call === "function")
    ? call
    : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError(
      "Super expression must either be null or a function, not " +
        typeof superClass
    );
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true,
    },
  });
  if (superClass)
    Object.setPrototypeOf
      ? Object.setPrototypeOf(subClass, superClass)
      : (subClass.__proto__ = superClass);
}

var TimeInput = (function(_Component) {
  _inherits(TimeInput, _Component);

  function TimeInput(props) {
    _classCallCheck(this, TimeInput);

    var _this = _possibleConstructorReturn(
      this,
      Object.getPrototypeOf(TimeInput).call(this, props)
    );

    _this.state = {
      time: _this.props.initTime || "",
    };
    _this.lastVal = "";
    return _this;
  }

  _createClass(TimeInput, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        if (!this.props.disabled && this.props.mountFocus) {
          setTimeout(function() {
            _this2._input.focus();
          }, 0);
        }
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var _this3 = this;
      },
    },
    {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.initTime) {
          this.onChangeHandler(nextProps.initTime);
        }
      },
    },
    {
      key: "isValid",
      value: function isValid(val) {
        var letterArr = val
            .split(":")
            .join("")
            .split(""),
          regexp = /^\d{0,2}?\:?\d{0,2}$/,
          valArr = [];

        var _val$split = val.split(":");

        var _val$split2 = _slicedToArray(_val$split, 2);

        var hoursStr = _val$split2[0];
        var minutesStr = _val$split2[1];

        if (!regexp.test(val)) {
          return false;
        }

        var hours = Number(hoursStr);
        var minutes = Number(minutesStr);

        var isValidHour = function isValidHour(hour) {
          return Number.isInteger(hours) && hours >= 0 && hours < 100;
        };
        var isValidMinutes = function isValidMinutes(minutes) {
          return (
            (Number.isInteger(minutes) && hours >= 0 && hours < 100) ||
            Number.isNaN(minutes)
          );
        };
        if (!isValidHour(hours) || !isValidMinutes(minutes)) {
          return false;
        }

        if (minutes < 10 && Number(minutesStr[0]) > 5) {
          return false;
        }

        if (valArr.indexOf(":")) {
          valArr = val.split(":");
        } else {
          valArr.push(val);
        }

        // check mm and HH
        if (
          valArr[0] &&
          valArr[0].length &&
          (parseInt(valArr[0], 10) < 0 || parseInt(valArr[0], 10) > 99)
        ) {
          return false;
        }

        if (
          valArr[1] &&
          valArr[1].length &&
          (parseInt(valArr[1], 10) < 0 || parseInt(valArr[1], 10) > 59)
        ) {
          return false;
        }

        return true;
      },
    },
    {
      key: "onChangeHandler",
      value: function onChangeHandler(val) {
        if (val == this.state.time) {
          return;
        }
        if (this.isValid(val)) {
          if (
            val.length === 2 &&
            this.lastVal.length !== 3 &&
            val.indexOf(":") === -1
          ) {
            val = val + ":";
          }

          if (val.length === 2 && this.lastVal.length === 3) {
            val = val.slice(0, 1);
          }

          if (val.length > 5) {
            return false;
          }

          this.lastVal = val;

          this.setState({
            time: val,
          });

          if (val.length === 5) {
            this.props.onTimeChange(val);
          }
        }
      },
    },
    {
      key: "onBlurHandler",
      value: function onBlurHandler(event) {
        let val = this.state.time;
        if (!val) {
          return;
        }
        if (this.isValid(val)) {
          switch (val.length) {
            case 1:
              if (val.indexOf(":") === -1) {
                val = "0" + val + ":00";
              } else {
                val = "00" + val + "00";
              }
              break;
            case 2:
              if (val.indexOf(":") === -1) {
                val = val + ":00";
              } else {
                if (val.indexOf(":") === 1) {
                  val = "0" + val + "00";
                } else {
                  val = "00" + val + "0";
                }
              }
              break;

            case 3:
              if (val.indexOf(":") === 2) {
                val = val + "00";
              } else {
                if (val.indexOf(":") === 1) {
                  val = "0" + val + "0";
                } else {
                  val = "00" + val;
                }
              }
              break;

            case 4:
              if (val.indexOf(":") === 2) {
                val = val + "0";
              } else {
                val = "0" + val;
              }
              break;
          }

          if (val.length === 2 && this.lastVal.length === 3) {
            val = val.slice(0, 1);
          }

          this.lastVal = val;

          this.setState({
            time: val,
          });

          if (val.length === 5) {
            this.props.onTimeChange(val);
          }
        }
      },
    },
    {
      key: "getType",
      value: function getType() {
        if (this.props.type) {
          return this.props.type;
        }
        return "tel";
      },
    },
    {
      key: "render",
      value: function render() {
        var _this4 = this;

        return _react2.default.createElement("input", {
          name: this.props.name ? this.props.name : undefined,
          className: this.props.className,
          type: this.getType(),
          disabled: this.props.disabled,
          placeholder: this.props.placeholder,
          value: this.state.time,
          onChange: function onChange(e) {
            return _this4.onChangeHandler(e.target.value);
          },
          onFocus: this.props.onFocusHandler
            ? function(e) {
                return _this4.props.onFocusHandler(e);
              }
            : undefined,
          onBlur: function onBlur(e) {
            return _this4.onBlurHandler(e);
          },
          ref: function ref(c) {
            return (_this4._input = c);
          },
        });
      },
    },
  ]);

  return TimeInput;
})(_react.Component);

TimeInput.defaultProps = {
  placeholder: " ",
};

exports.default = TimeInput;
